import mitt from 'mitt'

// Event bus globale — sostituisce `Vue.prototype.$bus = new Vue({})` (Vue 2).
// API drop-in: $bus.on / $bus.off / $bus.emit
// (in Vue 2 si usava $bus.$on / $bus.$emit — adeguare le chiamate in Fase 4).
const bus = mitt()

export default bus
